export default (value) => {
  return value === undefined || value === null
}
